import { useDispatch } from 'react-redux';
import { submitTurn } from '@/store/gameSlice';
import type { AppDispatch } from '@/store';
import type { GameState } from '@/types';

export function StoreLandOffer({ game, gameId }: { game: GameState; gameId: string }) {
  const dispatch = useDispatch<AppDispatch>();
  const listings = game.store?.landForSale || [];
  if (!listings.length) return null;
  return (
    <aside className="store-land-offer">
      <h2>Store land</h2>
      {game.bulletin ? <p>{game.bulletin}</p> : null}
      {listings.map((plot) => (
        <p key={plot.plotId}>
          {plot.terrain || 'Plot'} · {plot.price} CT
          <button
            type="button"
            onClick={() => dispatch(submitTurn({
              gameId,
              turnData: { action: 'buy_plot', data: { plotId: plot.plotId } },
            }))}
          >
            Buy
          </button>
        </p>
      ))}
    </aside>
  );
}
